import InfoIcon from "../../assets/svg/InfoIcon";
import dataConstants from "../../constants/dataConstants";
import RequiredFieldTooltip from "../global/RequiredFieldTooltip";
import "./tableStyle.css";

function StatusCell({ cell, row }: { cell: any; row: any }) {
  const status =
    !!row.original.status && typeof row.original.status === "string"
      ? row.original.status
      : !!row.original.orderStatus
      ? row.original.orderStatus
      : "";

  const textColor = dataConstants.textColors[status?.toLowerCase() ?? ""];

  // Function to capitalize first letter of each word
  const formatStatus = (statusText: string) => {
    if (statusText === "COA Order Attestation") return statusText;
    return statusText
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <div
      style={{
        backgroundColor: dataConstants.bgColors[status?.toLowerCase() ?? ""],
        color: textColor,
      }}
      className={`py-1 px-2 rounded-full text-xs ${
        status === "Cancelled"
          ? "flex items-center justify-center gap-2 min-w-[100px]"
          : "block w-max text-center"
      }`}
    >
      {formatStatus(status)}
      {status === "Cancelled" && (
        <RequiredFieldTooltip
          tooltipText={`${row?.original?.cancelledReason}`}
          required={true}
          showLeft={true}
          id="cancelledReason"
        
        >
          <InfoIcon stroke={textColor} className="shrink-0" />
        </RequiredFieldTooltip>
      )}
    </div>
  );
}

export default StatusCell;
